module.exports = __webpack_public_path__ + "img/rosemount-2051-dp-flow-transmitter-1-5-valves.6af88603.png";